import { createNgReactBridgeController } from '../../react-bridge'

import { SuperadminGeneralInternetCtrl } from './superadmin-general-internet.controller'

createNgReactBridgeController(
  'SuperadminGeneralInternetCtrl',
  SuperadminGeneralInternetCtrl
)
